export const NV = "N/V";
export const NA = "N/A";
export const YES = "Yes";
export const NO = "No";